import { BASE_URL, WORKSHOPS_PER_CLIENT_REPORT, GET_VENDOR_COMPANIES } from "constants/api";
import axios from "../helpers/axiosInstance";

export interface IWorkshopsPerClientReport {
  id: string;
  company: string;
  topic: string;
  fromDate: string;
  toDate: string;
  trainer: string;
  pretestAverage: number;
  posttestAverage: number;
  evaluationAverage: number;
  enrollmentCount: number;
}

export interface ICompanyOption {
  id: string;
  name: string;
  nameAr: string;
}

export async function getWorkshopsPerClient(
  fromDate?: string,
  toDate?: string,
  companyId?: string
): Promise<IWorkshopsPerClientReport[]> {
  const params = new URLSearchParams();
  if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);
  if (companyId) params.append("companyId", companyId);

  const response = await axios.get(
    `${BASE_URL}${WORKSHOPS_PER_CLIENT_REPORT}${params.toString() ? '?' + params.toString() : ''}`
  );
  return response.data;
}

export async function getVendorCompanies(): Promise<ICompanyOption[]> {
  const response = await axios.get(BASE_URL + GET_VENDOR_COMPANIES);
  return response.data;
}

